// Sends the app's own failures to the backend (POST /api/client-errors) so
// they show in /admin → Logs → Errores instead of staying on the phone.
// Only what failed and where: never amounts, form values or request bodies.
// Plain fetch (not the axios instance) so a failing report can't trigger
// another report through the interceptor.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const TOKEN_KEY = 'moneytrack_token';
const MAX_PER_SESSION = 20;

const seen = new Set();
let sent = 0;

function currentPage() {
  try {
    const p = new URLSearchParams(window.location.search).get('page');
    return p || window.location.pathname || '/';
  } catch (_) { return ''; }
}

export function reportClientError({ kind, message = '', stack = '', path = '', method = '', status = null }) {
  try {
    const key = `${kind}|${method}|${path}|${status}|${String(message).slice(0, 120)}`;
    if (seen.has(key) || sent >= MAX_PER_SESSION) return;
    seen.add(key);
    sent += 1;
    let token = null;
    try { token = localStorage.getItem(TOKEN_KEY); } catch (_) { /* storage unavailable */ }
    fetch(`${BACKEND_URL}/api/client-errors`, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      body: JSON.stringify({
        kind,
        message: String(message || '').slice(0, 500),
        stack: String(stack || '').slice(0, 4000),
        page: currentPage().slice(0, 60),
        path: String(path || '').split('?')[0].slice(0, 200),
        method: String(method || '').toUpperCase().slice(0, 10),
        status,
      }),
    }).catch(() => {});
  } catch (_) { /* reporting must never break the app */ }
}

// What the user reads when something fails: the backend's message when it's
// a plain sentence meant for people (our API answers in short Spanish), the
// caller's fallback otherwise — never codes, English library errors or stacks.
export function friendlyError(e, fallback = 'Algo salió mal. Intenta de nuevo.') {
  const detail = e?.response?.data?.detail;
  if (typeof detail !== 'string') return fallback;
  const d = detail.trim();
  const technical = d.length > 180
    || /error|exception|traceback|undefined|null|\{|\}|status code|failed|http/i.test(d);
  return d && !technical ? d : fallback;
}
